import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import * as moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { AdvancedAnalyticsServices } from '../../advanced-analytics-services';
import { SelectBetweenDatetime } from '../../../components/popups/select-between-datetime/select-between-datetime';
import { FormBuilder, Validators } from '@angular/forms';
import firebase from 'firebase';

/**
 * Generated class for the SalesSalesPerM2Page page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-sales-sales-per-m2',
  templateUrl: 'sales-sales-per-m2.html',
})
export class SalesSalesPerM2Page {
  m2: any;
  m2Form: any;
  firestore;
  chartData: any;
  chartLabels: any;
  chartCheck: any;
  result: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public http: HttpClient,
    public fb: FormBuilder,
    public advancedAnalyticsServices: AdvancedAnalyticsServices,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController,
  ) {

    this.firestore = firebase.firestore();
    this.m2 = this.globals.restaurant.analytics_m2_active;
    this.m2Form = this.fb.group({
      m2: ['', [Validators.required, Validators.pattern("[a-z0-9.-]{1,}")]],
    });

    this.getAnalyticsData();
  }


  async check() {
    //Comprovamos limites de la licencia
    if (this.m2Form.valid) {
      this.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'analytics_m2_active': this.m2,
      });
      //toast
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-guardado-correctamente'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
      this.getAnalyticsData();
    }

  }


  //funcion que abre el modal para seleccionar fechas
  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('analytics-titulo-fechas'),
      date_first: this.advancedAnalyticsServices.date1,
      date_last: this.advancedAnalyticsServices.date2,
      cash_bool: false,
    });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.advancedAnalyticsServices.date1 = data.date_first;
        this.advancedAnalyticsServices.date2 = data.date_last;
        //
        this.getAnalyticsData();
      }
    });
    profileModal.present();
  }

  async getAnalyticsData() {

    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'))
      .set('currency_lang', this.globals.currency_lang);

    this.chartCheck = false;//boolean check
    this.http.post(this.globals.analytics_path + 'analytics/sales_sales_per_m2', params, {})
      .subscribe(async response => {
        this.result = parseFloat(response['total_per_m2']).toFixed(2);
        //
        this.chartCheck = true;//boolean check
      });
  }

  export() {
    const params = new HttpParams()
      .set('data', JSON.stringify([{ "Total sales per m2": parseFloat(this.result).toFixed(2), "m2": this.m2 }]))
      .set('date1', moment(this.advancedAnalyticsServices.date1).format('DD/MM/YYYY HH:mm:ss'))
      .set('date2', moment(this.advancedAnalyticsServices.date2).format('DD/MM/YYYY HH:mm:ss'))
      .set('extras', JSON.stringify({}));
    this.http.post(this.globals.analytics_path + 'export/analytics', params, {})
      .subscribe(async res => {
        if (this.globals.so_mobile) {
          window.location.assign(res['task']);
        } else {
          window.open(res['task'], '_blank');
        }
      });
  }

}


// WEBPACK FOOTER //
// ./src/pages/analytics/reports/sales-sales-per-m2/sales-sales-per-m2.ts